<script setup>
import PageLayout from '@/components/result/ai-literacy/PageLayout.vue';
import Page1 from './Page1.vue';
import Page2 from './Page2.vue';
import Page3 from './Page3.vue';
import Page4 from './Page4.vue';

const pages = [Page1, Page2, Page3, Page4];

const subTitle = "학생 진단검사 결과지";
</script>

<template>
  <PageLayout 
    v-for="(Component, index) in pages" 
    :key="index"
    :current-page="index + 1"
    :total-pages="pages.length"
    :sub-title="subTitle"  >
    <component :is="Component" />
  </PageLayout>
</template>